import { Navigate } from 'react-router-dom';

import useParentAuth from '../hooks/useParentAuth';
import { getLandingRouteForUser, normalizeRole } from '../utils/auth';

const RoleProtectedRoute = ({ children, allowedRoles = [], redirectTo = '/' }) => {
  const { user, isAuthenticated } = useParentAuth();

  if (!isAuthenticated || !user) {
    return <Navigate to={redirectTo} replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(normalizeRole(user.role))) {
    return <Navigate to={getLandingRouteForUser(user) || redirectTo} replace />;
  }

  return children;
};

export default RoleProtectedRoute;
